import React, { FC, PropsWithChildren } from 'react'
import { OldThemeContext } from '@shared/lib'
import { theme } from '@shared/config'

const OldThemeProvider: FC<PropsWithChildren> = ({ children }) => (
  <OldThemeContext.Provider value={theme}>{children}</OldThemeContext.Provider>
)

export default OldThemeProvider
